module.exports = __webpack_public_path__ + "img/base_activites_longue_randonnee.2e65ffd3.svg";